/**
 * Vite-freie Telemetrie-Skip-Logik (kein constants.ts).
 * Extract 415/422, Autosave-Stub und Folder-Rename nicht nach portal_telemetry POSTen.
 */

/** Normalisiert URL/Pfad — keine Query-Strings, keine PII. */
export function normalizeTelemetryEndpoint(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return '/unknown';
  try {
    if (/^https?:\/\//i.test(trimmed)) {
      const u = new URL(trimmed);
      return u.pathname || '/';
    }
  } catch {
    /* relative Pfad */
  }
  const pathOnly = trimmed.split('?')[0]?.split('#')[0] ?? trimmed;
  return pathOnly.startsWith('/') ? pathOnly : `/${pathOnly}`;
}

export function isIncompleteTelemetryPayload(payload: {
  endpoint: string;
  status: number;
}): boolean {
  if (!payload.endpoint || payload.endpoint === '/unknown') return true;
  if (!Number.isFinite(payload.status)) return true;
  return false;
}

/** Extract 415/422 sind UI-Fallbacks, kein Beta-Capture (sonst PB 422-Spam). */
export function shouldSkipPortalTelemetryWebhook(path: string, status: number): boolean {
  // Folder/rename: User-Bar ist Quelle; Interceptor-POST nach PB wäre nur Logging-Noise.
  if (path.includes('portal-document-folder')) return true;
  if (!path.includes('portal-onlyoffice-extract-text')) return false;
  return status === 415 || status === 422;
}

/**
 * Ungültige/erwartete Payloads nicht nach portal_telemetry POSTen
 * (fehlender fileType, Autosave-Stub, Extract 415/422, unvollständiger Endpoint).
 */
export function shouldSkipPortalTelemetryPayload(args: {
  endpoint?: string;
  status?: number;
  fileType?: string | null;
  autosaveStub?: boolean;
}): boolean {
  if (args.autosaveStub) return true;
  const endpoint = normalizeTelemetryEndpoint(String(args.endpoint || ''));
  const status = args.status;
  if (typeof status !== 'number' || isIncompleteTelemetryPayload({ endpoint, status })) {
    return true;
  }
  if (shouldSkipPortalTelemetryWebhook(endpoint, status)) return true;
  if (
    args.fileType !== undefined &&
    endpoint.includes('portal-onlyoffice-extract-text') &&
    !String(args.fileType || '').trim()
  ) {
    return true;
  }
  return false;
}
